'use client';

import {
  createContext,
  ReactNode,
  useContext,
  useReducer,
  Dispatch,
} from 'react';
import {
  encountersReducer,
  initialEncountersState,
  EncountersActionTypes,
  EncountersState,
} from '../reducers/encountersReducer';

type EncountersContextType = {
  state: EncountersState;
  dispatch: Dispatch<any>;
};

const EncountersContext = createContext<EncountersContextType>({
  state: initialEncountersState,
  dispatch: () => null,
});

export const EncountersProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(
    encountersReducer,
    initialEncountersState
  );

  return (
    <EncountersContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </EncountersContext.Provider>
  );
};

export const useEncounters = (): EncountersContextType => {
  const context = useContext(EncountersContext);
  if (!context) {
    throw new Error('useEncounters must be used within an EncountersProvider');
  }
  return context;
};

export { EncountersActionTypes };
